import { rootContainer } from 'app/shadowRoot';

export default function useIsIntegratedView() {
  return rootContainer.querySelector('#ostro-integrated-app-container') !== null;
}
